<template lang="pug">
  section(id="hero")
     .goscontainer
        v-row.device(no-gutters)
            v-col(cols=12 md=7)
                div.head Модульная многопользовательская платформа для аппарата суда и участников судопроизводства
                div.body Создано с учетом потребностей профессионального сообщества
                div.supp При поддержке:<br/> Совета судей Санкт-Петербурга<br/> ФГБУ ИАЦ "Судебного департамента" в Санкт-Петербурге
            v-col.align-content-end.justify-content-between(cols=12 md=5)
                v-img.mx-auto(:src="require('@/assets/img/home/box.png')" max-width="517")

</template>

<script>
  export default {
    name: 'SectionHero'
  }

</script>


<style lang="sass" scoped>
  #hero
    margin-bottom: -144px
    padding: 0 16px
    .device
        font-family: $slab
        font-weight: 300
        .head
            margin-top: 56px
            font-size: 36px
            line-height: 56px
        .body
            margin-top: 40px
            font-size: 24px
        .supp
            margin-left: 120px
            margin-top: 56px
            margin-bottom: 40px
            font-size: 14px
            line-height: 24px
            color: #314369
  @media (max-width: 1210px) 
    #hero
      .device
          .head
              margin-top: 20px
          .body
              margin-top: 20px
          .supp
              margin-top: 20px
  @media (max-width: 1180px) 
    #hero
      margin-bottom: -90px
      .device
          .head
              font-size: 26px
          .body
              font-size: 20px
  @media (max-width: 960px) 
    #hero
      margin-bottom: 0

</style>
